import { CommonModule } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface IncompleteProfileFundingDialogData {
  title?: string;
  message?: string;
}

@Component({
  selector: 'app-incomplete-profile-funding-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
    <div class="p-6 text-center max-w-sm mx-auto">
      <!-- Icon -->
      <div class="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
        <svg class="w-8 h-8 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
        </svg>
      </div>

      <h2 class="text-lg font-semibold text-gray-900 mb-2">{{ title }}</h2>
      <p class="text-sm text-gray-500 mb-6">
        {{ message }}
      </p>

      <div class="flex flex-col gap-3">
        <button
          (click)="goToProfile()"
          class="w-full px-4 py-2.5 text-sm font-medium text-white bg-primary-600 rounded-lg hover:bg-primary-700 transition-colors"
        >
          Completar perfil
        </button>
        <button
          (click)="goBack()"
          class="w-full px-4 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-800 transition-colors"
        >
          Volver
        </button>
      </div>
    </div>
  `,
})
export class IncompleteProfileFundingDialogComponent {
  title = 'Perfil incompleto';
  message = 'Para poder recargar tu cuenta, necesitas completar los datos de tu perfil primero.';

  constructor(
    private dialogRef: MatDialogRef<IncompleteProfileFundingDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: IncompleteProfileFundingDialogData
  ) {
    if (data?.title) this.title = data.title;
    if (data?.message) this.message = data.message;
  }

  goToProfile() {
    this.dialogRef.close('complete');
  }

  goBack() {
    this.dialogRef.close('back');
  }
}
